<template>
  <div class="content mb-5">
    <b-row class="mb-5">
      <b-col>
        <t-data-table
          data-test-id="msps-data-table"
          with-filter
          hoverable
          :filter-placeholder="$t('Search MSP')"
          :loading="loading"
          :title="this.$t('All MSPs')"
          :table-data="dataSet"
          :actions="tableActions"
          user-role="sales"
          @on-add="onAdd"
          @on-export="onExport"
          @on-delete="onDelete"
          @on-row-clicked="onRowClicked"
        />
      </b-col>
    </b-row>
  </div>
</template>

<route>
{
  "name": "Sales Managed Service Providers",
  "meta": {
    "authorize" : [1, 2]
  }
}
</route>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  layout: "sales",
  data() {
    return {
      loading: true,
      tableActions: {
        add: {
          enabled: true,
          actions: [
            {
              text: this.$t("Add"),
              value: "add",
            },
          ],
        },
        export: { enabled: false },
        import: { enabled: false },
        delete: { enabled: false },
      },
      dataSet: {
        fields: [
          { value: "name", text: this.$t("Name"), sortable: true },
          { value: "email", text: this.$t("Email"), sortable: true },
          {
            value: "description",
            text: this.$t("Description"),
            sortable: false,
          },
          { value: "created_at", text: this.$t("Created At"), sortable: true },
          { value: "id", text: this.$t("MSP ID"), sortable: false },
        ],
        items: [],
      },
    };
  },
  computed: {
    ...mapGetters("msps", ["msps"]),
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle"]),
    ...mapActions("msps", ["fetchMsps", "deleteMsp"]),
    ...mapMutations("modal", ["createModal", "showModal"]),
    ...mapActions("toast", ["displayToast"]),

    onAdd() {
      this.createModal({
        modal: "t-add-msps",
        title: this.$t("Add an MSP"),
        subtitle: "",
        modalData: {
          msp: [],
        },
        props: {
          size: "lg",
          okTitle: this.$t("Add MSP"),
        },
      });

      this.showModal();
    },
    onRowClicked(item) {
      this.$router.push(`/sales/msps/${item.id}`);
    },
    async onDelete(items) {
      for await (const item of items) {
        await this.deleteMsp({
          id: item.id,
        });
      }
    },
    onExport(items) {
      this.$downloadCSV(items, "msps");
    },
  },
  watch: {
    msps: {
      handler() {
        this.dataSet.items = this.msps;
      },
      immediate: true,
    },
  },

  async created() {
    this.setPageTitle(this.$t("Managed Service Providers"));
    try {
      await this.fetchMsps({ id: this.id });
    } finally {
      this.dataSet.items = this.msps;
      this.loading = false;
    }
  },
};
</script>
